import React from "react";
import { Link } from "react-router-dom";
import profileIcon from "../../images/icon/profile-circle.svg";

interface BlogSidebarProps {
  blogData: { img: string; tag: string; title: string; content: string }[];
  setCategoryFilter: (tag: string | null) => void;
}

const Icons = {
  search: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M14.002 5H20.002" stroke="#00020F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.002 8H17.002" stroke="#00020F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M21.002 11.5C21.002 16.75 16.752 21 11.502 21C6.25195 21 2.00195 16.75 2.00195 11.5C2.00195 6.25 6.25195 2 11.502 2"
        stroke="#00020F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      />
      <path d="M22.002 22L20.002 20" stroke="#00020F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const BlogSidebar: React.FC<BlogSidebarProps> = ({ blogData, setCategoryFilter }) => {
  // Compute category counts dynamically
  const categoryCounts = blogData.reduce<Record<string, number>>((acc, item) => {
    acc[item.tag] = (acc[item.tag] || 0) + 1;
    return acc;
  }, {});

  // Related posts: just take first 3 items
  const relatedPosts = blogData.slice(0, 3).map((b) => ({
    title: b.title,
    author: "Aditya",
  }));

  return (
    <div className="col-lg-4 mt-50">
      <div className="sidebar">

        {/* SEARCH WIDGET */}
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Search</h3>
          <div className="form-group">
            <input className="form-control" type="search" placeholder="Search..." />
            <button type="submit" className="search_icon">
              <span>{Icons.search}</span>
            </button>
          </div>
        </div>

        {/* RELATED POSTS */}
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Related posts</h3>
          <ul className="recent_post_block list-unstyled">
            {relatedPosts.map((post, i) => (
              <li key={i} className="recent_post_item xb-border">
                <h3 className="post-title border-effect-2">
                  <Link to="#" onClick={(e) => e.preventDefault()}>{post.title}</Link>
                </h3>
                <span>
                  <img src={profileIcon} alt="author" /> By {post.author}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* CATEGORIES */}
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Categories</h3>
          <ul className="category_list_block list-unstyled">
            {Object.entries(categoryCounts).map(([name, count], i) => (
              <li key={i}>
                <Link to="#"
                  onClick={(e) => { e.preventDefault(); setCategoryFilter(name); }}>
                  <span><i className="far fa-arrow-right"></i> {name}</span>
                  <span>({count.toString().padStart(2, "0")})</span>
                </Link>
              </li>
            ))}
            <li>
              <Link to="#"
                onClick={(e) => { e.preventDefault(); setCategoryFilter(null); }}>
                <span><i className="far fa-arrow-right"></i> All</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* TAGS
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Tags</h3>
          <ul className="tags_block list-unstyled">
            {["Blockchain", "NFT", "Crypto", "FinTech", "CryptoMarketing"].map((tag, i) => (
              <li key={i}>
                <Link className="xb-border" to="#"
                  onClick={(e) => { e.preventDefault(); setCategoryFilter(tag); }}>
                  {tag}
                </Link>
              </li>
            ))}
          </ul>
        </div> */}

      </div>
    </div>
  );
};

export default BlogSidebar;
